import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'price', 'eightHundredFlag']);
  const modifySpecialPrice = `modifySpecialPrice(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifySpecialPrice} {
      id
    }
  }
`;
};
